import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zhCN from './langs/zh-CN.json'
import enUS from './langs/en-US.json'
import thTH from './langs/th-TH.json'

Vue.use(VueI18n)

function detectBrowserLanguage() {
  const lang = (navigator.language || navigator.userLanguage || 'zh-CN').toLowerCase()
  if (lang.startsWith('zh')) return 'zh-CN'
  if (lang.startsWith('en')) return 'en-US'
  if (lang.startsWith('th')) return 'th-TH'
  return 'zh-CN'
}

const saved = window.localStorage.getItem('lang')
const locale = saved || detectBrowserLanguage()

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'th-TH': thTH,
  },
})

export default i18n


